module.exports = __webpack_public_path__ + "img/animal.2964e216.svg";